export default __webpack_public_path__ + "static/media/40_aniversario_logo.4a5d932e.png";